<script setup>
import { ref, onMounted } from "vue";
import { replaceTags, insetIconPen } from "@/views/grammar/js/TagAnalysis";
import { textToPlayAudio } from "@/js/textToPlayAudio";
import InnerContainer from "@/views/grammar/newGrammar/components/InnerContainer.vue";
import iconPen from "@/assets/grammar/fill_icon.png";
import audioPlay from "@/assets/grammar/audio_play.svg";
import audioPause from "@/assets/grammar/audio_pause.png";
import audioPlaying1 from "@/assets/grammar/audio_playing1.png";
import audioPlaying2 from "@/assets/grammar/audio_playing2.png";
import translate from "@/assets/grammar/icon-translate.svg";
import translate_h from "@/assets/grammar/icon-translate_h.svg";
import store from "@/js/store";

const props = defineProps(["templateData"]);

const audioIcon = ref(audioPlay);

const audioStatus = ref(null);

const audioSentencePath = ref("");

const audioPlaySentenceRef = ref();

const audioTimer = ref(null);

const translateIcon = ref(translate_h);

const ossUrl = `${store.getOEMBASE() || ""}grammar_content/`;

const showTranslate = ref(false);

// 处理内容中的特殊标签
const processContent = (content) => {
  if(content){
    return replaceTags(content)
  }else{
    return ""
  }

};

function handleTranslate() {
  showTranslate.value = !showTranslate.value;
  if (showTranslate.value) {
    translateIcon.value = translate;
  } else {
    translateIcon.value = translate_h;
  }
}

function handleAudio() {
  const audioText = document.querySelectorAll(".template-article")[0].textContent;
  let num = 0;
  if (audioStatus.value !== "playing") {
    const regex = /\s*\([^)]*\)/g; //匹配文本中的括号
    const result = audioText.trim().replace(regex, ""); // 替换匹配的内容为空字符串
    textToPlayAudio(result, (url) => {
      if (!audioSentencePath.value) {
        audioSentencePath.value = url;
        audioPlaySentenceRef.value.oncanplay = function () {
          audioPlaySentenceRef.value.play();
        };
      } else {
        audioPlaySentenceRef.value.play();
      }
      audioIcon.value = audioPlaying1;
      if (!audioTimer.value) {
        audioTimer.value = setInterval(() => {
          audioIcon.value = ++num % 2 ? audioPlaying1 : audioPlaying2;
        }, 300);
      }
      audioPlaySentenceRef.value.onplaying = function () {
        audioStatus.value = "playing";
      };
      audioPlaySentenceRef.value.onended = function () {
        audioStatus.value = "end";
        window.clearInterval(audioTimer.value);
        audioTimer.value = null;
        audioIcon.value = audioPlay;
        audioSentencePath.value = null;
      };
    });
  } else {
    audioStatus.value = "paused";
    window.clearInterval(audioTimer.value);
    audioTimer.value = null;
    audioIcon.value = audioPause;
    audioPlaySentenceRef.value.pause();
  }
}

</script>

<template>
  <InnerContainer :title="templateData.pageTitle" :subTitle="templateData.problem">
    <div class="template-content">
      <img class="banner-img" :src="ossUrl + templateData.content[0].imageUrl" />
      <p class="template-article" v-html="processContent(templateData.content[0].content)"></p>
      <div class="tool-cell">
        <img v-if="templateData.content[0].content" class="tool-icon" :src="audioIcon" alt="" @click="handleAudio" />
        <img
          class="tool-icon"
          :src="translateIcon"
          alt=""
          @click="handleTranslate"
          v-if="templateData.content[0].translation"
        />
      </div>
      <div class="translate-text" v-if="showTranslate">
        {{ templateData.content[0].translation }}
      </div>
      <div
        v-if="templateData.content[0].explanation"
        class="mt-4 explanation-box"
        v-html="processContent(templateData.content[0].explanation)"
      ></div>
    </div>
    <audio id="audioPlay" ref="audioPlaySentenceRef" :src="audioSentencePath">播放句子</audio>
  </InnerContainer>
</template>

<style scoped lang="less">
.template-content {
  background-color: white;
  border-radius: 0.5rem;
  padding: 1rem;
  color: #3f4140;
  font-weight: 500;

  .banner-img {
    width: 100%;
    height: 14rem;
    background-color: #999999;
  }

  .template-article {
    font-size: 1rem;
    line-height: 1.7rem;
  }

  .tool-cell {
    .tool-icon {
      width: 1.3rem;
      height: 1.3rem;
      margin-right: 0.67rem;
    }
  }

  .translate-text {
    background-color: #f2f3f6;
    border-radius: 0.65rem;
    font-size: 1rem;
    padding: 0.6rem;
    margin-top: 0.68rem;
  }
}
</style>
